import api from './api';

export async function featureToggle(id) {
    if (!id) return {};

    const { data } = await api.get(`features?restaurantId=${id}`);
    if (data) return data;
}
